module.exports = __webpack_public_path__ + "static/media/fr_qr.4ce5cb50.jpg";